module.exports = __webpack_public_path__ + "img/album05_08.7ae7a300.jpg";